$(document).ready(function() {

  var inzone = false;


      $("#checkpostcode").click(function(){
         $("#pc_message").text("");
         var pc = $("#postcode").val();
        if ((3000 <= pc ) && (pc <= 3999))
         {
            

              // 10km var freezone = ['3000','3001','3002','3003','3004','3005','3006','3008','3010','3011','3012','3013','3015','3016','3019','3025','3031','3032','3039','3040','3041','3044','3050','3051','3052','3053','3054','3055','3056','3057','3058','3060','3065','3066','3067','3068','3070','3071','3072','3078','3079','3081','3101','3102','3103','3104','3121','3122','3123','3124','3126','3141','3142','3143','3144','3145','3146','3161','3162','3181','3182','3183','3184','3185','3188','3205','3206','3207'];

//				var freezone = ['3000','3001','3002','3003','3004','3005','3006','3008','3010','3011','3012','3013','3015','3016','3018','3019','3020','3021','3022','3023','3025','3026','3027','3028','3029','3030','3031','3032','3033','3034','3036','3037','3038','3039','3040','3041','3042','3043','3044','3046','3047','3048','3049','3050','3051','3052','3053','3054','3055','3056','3057','3058','3060','3061','3062','3065','3066','3067','3068','3070','3071','3072','3073','3074','3075','3076','3078','3079','3081','3082','3083','3084','3085','3086','3087','3088','3093','3094','3095','3101','3102','3103','3104','3105','3106','3107','3108','3109','3111','3121','3122','3123','3124','3125','3126','3127','3128','3129','3130','3131','3132','3133','3141','3142','3143','3144','3145','3146','3147','3148','3149','3150','3151','3161','3162','3163','3165','3166','3167','3168','3169','3170','3181','3182','3183','3184','3185','3186','3187','3188','3189','3190','3191','3192','3193','3194','3204','3205','3206','3207','3800'];

           
           
           var freezone = ['3000','3002','3003','3004','3005','3006','3008','3010','3011','3012','3013','3015','3016','3018','3019','3020','3021','3022','3023','3025','3026','3027','3028','3031','3032','3033','3034','3036','3038','3039','3040','3041','3042','3043','3044','3045','3046','3047','3048','3049','3050','3051','3052','3053','3054','3055','3056','3057','3058','3060','3061','3062','3065','3066','3067','3068','3070','3071','3072','3073','3074','3075','3076','3078','3079','3081','3082','3083','3084','3085','3086','3087','3088','3093','3094','3095','3101','3102','3103','3104','3105','3106','3107','3108','3109','3111','3121','3122','3123','3124','3125','3126','3127','3128','3129','3130','3131','3132','3133','3141','3142','3143','3144','3145','3146','3147','3148','3149','3151','3161','3162','3163','3165','3166','3167','3168','3169','3170','3181','3182','3183','3184','3185','3186','3187','3188','3189','3190','3191','3192','3193','3204','3205','3206','3207','3800'];
           var check = jQuery.inArray(pc, freezone);

           var geelongzone = ['3211','3212','3213','3214','3215','3216','3217','3218','3219','3220','3221','3228','3222','3224','3227','3240','3331','3226','3922','3923','3924','3925','3926'];
           var checkgeelong = jQuery.inArray(pc, geelongzone);
 
           var mpzone = ['3936','3936','3938','3939','3937','3928','3940','3939','3941','3915','3941','3916','3943','3240','3939','3931','3941','3942','3939','3933','3918','3931','3929','3927','3915','3920', '3930','3919','3913','3927','3930','3944','3934'];
           var checkmp = jQuery.inArray(pc, mpzone);
          
           var clydezone = ['3912','3980','3981','3978','3978','3978','3809','3980','3980','3807','3810','3976','3808','3808','3912','3912','3975','3981','3981','3913','3912','3980', '3981','3990','3979','3945','3984','3987'];
  var checkclyde = jQuery.inArray(pc, clydezone);
                      var regionalzone = ['3350','3355','3356','3357','3550','3460'];
  var checkregional = jQuery.inArray(pc, regionalzone);
           
           if (checkregional >= 0) {
             
             	 $("#pc_message").text("You are in our Regional Zone, we deliver every 2nd Friday. Some post codes have a 3 bin minimum.");

           } else if (checkclyde >= 0) {
             
             	 $("#pc_message").text("You are within 20km of Clyde or Phillip Island Zone, we deliver THURSDAY and SATURDAY. Some post codes have a 3 bin minimum.");

           } else if (checkmp >= 0) {
             
             	 $("#pc_message").text("You are within 20km of Mornington Peninsula, we deliver THURSDAY and SATURDAY. Some post codes have a 3 bin minimum.");

           } else if (checkgeelong >= 0) {
           
       			//$("#pc_message").text("You are within 20km of Geelong CBD, we deliver MONDAY. Some post codes have a 3 bin minimum.");
              $("#pc_message").html('We do not currently deliver to Geelong area though please  <a href="/pages/register-your-interest">Register Your Interest here</a>');
           
           }  else  if (check >= 0)
          		{
                    inzone = true;

                    $("#pc_message").text("You are within 20km of Melbourne CBD, we deliver every day except Sunday and public holidays");


         		 } else {
        
                  //check east
                    if ((3101 <= pc ) && (pc <= 3148) || (pc == 3804) || (pc == 3806) || (pc == 3155) || (pc == 3178) || (pc == 3805) || (pc == 3802) || (pc == 3160) || (pc == 3150) )
                    {
                       $("#pc_message").text("You are in our East Zone, we deliver to your area on WEDNESDAY");
                      inzone = true;
                    }

                    //check west
                    else if ((3011 <= pc ) && (pc <= 3044)  || (pc == 3336) || (pc == 3337)|| (pc == 3037)  || (pc == 3029) || (pc == 3427) || (pc == 3335) || (pc == 3437) || (pc == 3338) || (pc == 3097) )
                             
                       
                    {
                       $("#pc_message").text("You are in our West Zone, we deliver to your area on MONDAY");
                      inzone = true;
                    }
     

                     //check south
                    else if ( ((3149 <= pc ) && (pc <= 3207)) || (pc == 3930) || (pc == 3976)  || (pc == 3977)  || (pc == 3910)   )
                    {
                       $("#pc_message").text("You are in our South Zone, we deliver to your area on THURSDAY");
                      inzone = true;
                    }

                      //check north
                   else  if ((3047 <= pc ) && (pc <= 3100) || (pc == 3752) || (pc == 3757) || (pc == 3754) || (pc == 3755)|| (pc == 3974) || (pc == 3975)  || (pc == 3429) || (pc == 3064) )
                    {
                       $("#pc_message").text("You are in our North Zone, we deliver to your area on TUESDAY");
                       inzone = true;
                    } else 
                    {
                      $("#pc_message").html('We do not deliver to your area yet though please <a href="/pages/register-your-interest">Register Your Interest here</a>');
                    }														
          
                   
                   
                   
       			 }  
         
         
         } else {
             	$("#pc_message").html('We do not deliver to your area yet though please  <a href="/pages/register-your-interest">Register Your Interest here</a>');
      
         }
        
        
    });
  
  

});

/*

post codes in radius

3000,3002,3003,3004,3005,3006,3008,3010,3011,3012,3013,3015,3016,3019,3025,3031,3032,3039,3040,3041,3044,3050,3051,3052,3053,3054,3055,3056,3057,3058,3060,3065,3066,3067,3068,3070,3071,3072,3078,3079,3081,3101,3102,3103,3104,3121,3122,3123,3124,3126,3141,3142,3143,3144,3145,3146,3161,3162,3181,3182,3183,3184,3185,3188,3205,3206,3207





*/

/*

MONDAY - West

TUESDAY - North

WEDNESDAY - East

THURSDAY - South



Victorian Postcodes
Ballarat
3350, 3352, 3353, 3354

Bendigo
3550, 3555, 3556

East (Melbourne)

3101-3148

Geelong
3214-3216, 3218-3220


Geelong / Queenscliff / Torquay
3214-3216, 3218-3228


Melbourne CBD
3000-3001


Mildura - Wentworth
2648, 3496, 3498, 3500, 2717


Mornington Peninsula
3931, 3934-3944


Morwell - Latrobe Valley
3825, 3828, 3838, 3840, 3844, 3842


North (Melbourne)
3047-3100


Phillip Island
3922-3926


Shepparton - Mooroopna
3629, 3630


South (Melbourne)
3149-3207


West (Melbourne)
3011-3044

*/